import { useTranslation } from 'react-i18next';
import React from 'react';
import { CompactPageLayout } from 'common/components/compactPageLayout';
import ScreenTitle from 'common/components/screenTitle/ScreenTitle';
import RulesTab from './components/rulesTab/RulesTab';
import styles from './AdminRulesScreen.module.scss';

const AdminRulesScreen = () => {
    const { t } = useTranslation();

    return (<ScreenTitle title={t('menu.rules')}>
        <CompactPageLayout title={t('menu.rules') as string}>
            <div className={styles.content}>
                <RulesTab isAdmin={true}/>
            </div>
        </CompactPageLayout>
    </ScreenTitle>)
}

export default AdminRulesScreen;